import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { CallbackComponent } from 'redux-oidc'
import { push } from 'connected-react-router'
import userManager from './userManager'
import Splash from 'App/Splash'

const Callback = ({ history, profile, redirectToLastLocation }) =>
  <CallbackComponent
    userManager={userManager}
    successCallback={redirectToLastLocation}
    errorCallback={error => {
      console.error(error)
      if (error.message === 'No matching state found in storage') {
        history.goBack()
      }
    }}
  >
    <Splash text='Estamos carregando a sua experiência.' />
  </CallbackComponent>

Callback.propTypes = {
  profile: PropTypes.object,
  redirectToLastLocation: PropTypes.func.isRequired,
  history: PropTypes.object
}

const mapStateToProps = ({ oidc }) => ({
  profile: oidc.user && oidc.user.profile
})

const mapDispatchToProps = dispatch => ({
  redirectToLastLocation: (user) => dispatch(push(user.state))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Callback)



// WEBPACK FOOTER //
// ./src/Auth/Callback.js